import { UnitSystem } from 'src/app/shared/enums/unit-system.enum';

// Default discrete temperatures T1..T5
export const GEOTHERMAL_TEMP_T_DEFAULTS: number[] = [100, 200, 300, 400, 500];

// Default LUS coefficients L1..L12
export const GEOTHERMAL_LUS_COEFF_DEFAULTS: number[] = [
  0,
  0.0625,
  0.125,
  0.250,
  0.333,
  0.400,
  0.450,
  0.500,
  1,
  2,
  3,
  4
];

// Centralized initial form defaults for Geothermal module
export function getGeothermalFormDefaults(unitSystem: UnitSystem = UnitSystem.USC) {
  // Defaults in USC (imperial)
  const tempDefaultsUSC = [100, 200, 300, 400, 500];
  const tempDefaultsSI = [37.8, 93.3, 148.9, 204.4, 260];
  const lusDefaults = GEOTHERMAL_LUS_COEFF_DEFAULTS;

  const baseUSC = {
    modulusE: 3.0e7, // psi
    poisson: 0.3,
    thermalExp: '6.9e-6', // 1/°F
    friction: 0.3,
    calcEccentricity: false,
    eccentricity: null,
    directionMotion: 'DOWN',
    outsideDiameter: null, // in
    nominalWeight: null, // lb/ft
    wallThickness: null, // in
    insideDiameter: null, // in
    grade: null,
    smys: null, // psi
    tempDerating: 0.03,
    hollLimit: null,
    holeId: null, // in
    insideDensityInitial: null, // ppg
    insideDensityFinal: null, // ppg
    outsideDensityInitial: null, // ppg
    outsideDensityFinal: null, // ppg
    insidePressureInitial: 0, // psi
    insidePressureFinal: 0, // psi
    outsidePressureInitial: 0, // psi
    outsidePressureFinal: 0, // psi
    avgTemperatureInitial: null, // °F
    avgTemperatureFinal: null, // °F
    deltaLPreload: 0, // in
    unsuppBkl: true,
    thermoCollapse: true
  };

  const baseSI = {
    modulusE: 206843, // MPa
    poisson: baseUSC.poisson,
    thermalExp: '1.24e-5', // 1/°C
    friction: baseUSC.friction,
    calcEccentricity: baseUSC.calcEccentricity,
    eccentricity: baseUSC.eccentricity,
    directionMotion: baseUSC.directionMotion,
    outsideDiameter: null, // mm
    nominalWeight: null, // kg/m
    wallThickness: null, // mm
    insideDiameter: null, // mm
    grade: baseUSC.grade,
    smys: null, // MPa
    tempDerating: baseUSC.tempDerating,
    hollLimit: null,
    holeId: null, // mm
    insideDensityInitial: null, // kg/m3
    insideDensityFinal: null, // kg/m3
    outsideDensityInitial: null, // kg/m3
    outsideDensityFinal: null, // kg/m3
    insidePressureInitial: 0, // kPa
    insidePressureFinal: 0, // kPa
    outsidePressureInitial: 0, // kPa
    outsidePressureFinal: 0, // kPa
    avgTemperatureInitial: null, // °C
    avgTemperatureFinal: null, // °C
    deltaLPreload: 0, // mm
    unsuppBkl: baseUSC.unsuppBkl,
    thermoCollapse: baseUSC.thermoCollapse
  };

  // Agregar tempT1..tempT5 y lusCoeffL1..lusCoeffL12
  const tempTDefaults = unitSystem === UnitSystem.USC ? tempDefaultsUSC : tempDefaultsSI;
  const base = unitSystem === UnitSystem.USC ? baseUSC : baseSI;
  const withTemps = { ...base };
  for (let i = 0; i < 5; i++) {
    withTemps[`tempT${i + 1}`] = tempTDefaults[i];
  }
  for (let i = 0; i < 12; i++) {
    withTemps[`lusCoeffL${i + 1}`] = lusDefaults[i];
  }
  return withTemps;
}
